import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import DriversComp from './DriversComp'


function Drivers() {
  return (
<div className='contentMain'> 
        <LeftBar/>
        <div className='theRightOne'> 
          <div className='DashTop'>
            <h1>Drivers</h1>
            <NavBar/>
          </div>
          <DriversComp/>
          
        </div>    
    </div>
  )
}

export default Drivers